module.exports = __webpack_public_path__ + "static/media/Pearls-Sophie-Bille-Brahe-Metallic-Lisa-Pave-Band-Lyst.125330d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/jewellery/Pearls-Sophie-Bille-Brahe-Metallic-Lisa-Pave-Band-Lyst.png
// module id = 241
// module chunks = 0